import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';

export const function_VEN_Reservas_Integrantes_Generar_JSON = async (IdItem, CodigoCompania, IdCliente, IdClienteResponsable) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_Generar_JSON";

    try {    
        const JSON = {
            IdItem: IdItem,
            CodigoCompania: CodigoCompania,
            IdCliente: IdCliente,
            IdClienteResponsable: IdClienteResponsable,
            FechaCheckIn: null
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_Insertar = async (Integrante) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_Insertar";

    try {
        await llamadaAPI_POST("VEN_Reservas_Integrantes", Integrante);
        return 1;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_Leer = async (IdItem, IdReserva) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_Leer"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Integrantes/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva + "/" +
            IdItem);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_Listar = async (IdReserva) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_Listar"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Integrantes/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_SoloSinCheckIn = async (IdReserva) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_SoloSinCheckIn"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Integrantes/SoloSinCheckIn/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_SoloSinCheckInPorItem = async (IdItem, IdReserva) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_SoloSinCheckInPorItem"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Integrantes/SoloSinCheckIn/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva + "/" +
            IdItem);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_SoloConCheckInPorItem = async (IdItem, IdReserva) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_SoloConCheckInPorItem"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Integrantes/SoloConCheckIn/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva + "/" +
            IdItem);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_Eliminar = async (IdItem, IdCliente) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_Leer"

    try {
        const resulData = await llamadaAPI_DELETE("VEN_Reservas_Integrantes/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            IdItem + "/" +
            IdCliente);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_Generar_JSONModificarCheckIn = async (IdReserva, IdItem, 
    IdCliente, Color, Control, FechaCheckIn) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_Generar_JSONModificarCheckIn";

    try {
        const JSON = {
            IdReserva: IdReserva,
            IdItem: IdItem,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdCliente: IdCliente,
            FechaCheckIn: FechaCheckIn,        
            FechaCreacion: FechaCheckIn,        
            Color: Color,
            Control: Control
        }
        return JSON
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_Generar_JSONModificarAgasajado = async (IdReserva, IdItem, 
    IdCliente, FechaCheckIn) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_Generar_JSONModificarAgasajado";

    try {
        const JSON = {
            IdReserva: IdReserva,
            IdItem: IdItem,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdCliente: IdCliente,
            FechaCreacion: FechaCheckIn
        }
        return JSON
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_ModificarCheckIn = async (Integrante) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_ModificarCheckIn";

    try {
        await llamadaAPI_PUT("VEN_Reservas_Integrantes/CheckIn/",
            Integrante);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_ModificarAgasajado = async (Integrante) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_ModificarAgasajado";

    try {
        await llamadaAPI_PUT("VEN_Reservas_Integrantes/ModificarAgasajado/",
            Integrante);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Reservas_Integrantes_ImpresionCheckIn = async (IdReserva, IdItem, IdCliente) => {
    const NombreFuncion = "function_VEN_Reservas_Integrantes_ImpresionCheckIn"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Integrantes/ImpresionCheckIn/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            localStorage.getItem("Terminal") + "/" +
            IdReserva + "/" +
            IdItem + "/" +
            IdCliente);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

1109/1269/209